import { Component, OnInit } from '@angular/core';
import { User } from 'src/app/models/user.model';
import { AuthOperatorService } from 'src/app/services/auth-operator.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-menu-operator',
  templateUrl: './menu-operator.component.html',
  styleUrls: ['./menu-operator.component.scss']
})
export class MenuOperatorComponent implements OnInit {
  public user: User;

  constructor(
    private auth: AuthOperatorService,
  ) { }

  ngOnInit(): void {
    this.user = this.auth.user
  }

  public get userAvatar(): string {
    if(this.user.photo) {
      return `${environment.apiUrl}/storage/img/${this.user.photo}`;
    }

    return "assets/img/avatar.png";
  }
}
